import Loader from './Loader';

const PageLoader = () => {
  return (
    <div className="h-[calc(100vh-120px)]">
      <Loader />
    </div>
  );
};

export default PageLoader;
